export const HAUL_AWAY_OPTIONS = [
  { cost: 0, price: 0 },
  { cost: 30, price: 30 },
  { cost: 40, price: 40 },
  { cost: 30, price: 40 },
]

export const getSavedHaulAwayFee = (invoice = {}) => {
  const fee = Number(invoice.haulAwayFee)
  if (Number.isFinite(fee) && fee > 0) return fee
  return invoice.haulAway ? 40 : 0
}

export const getSavedHaulAwayCost = (invoice = {}) => {
  const value = invoice.haulAwayCost
  const cost = Number(value)
  if (value !== undefined && value !== null && value !== '' && Number.isFinite(cost) && cost >= 0) return cost
  // Older invoices charged the same amount for cost and price.
  return getSavedHaulAwayFee(invoice)
}

export const formatHaulAwayOption = (option) => option?.price ? `$${option.cost}/$${option.price}` : 'None'
